const normalizeValueGroup = (values: readonly string[] | undefined): readonly string[] =>
    Array.isArray(values) ? values : [];

export const buildInclusionConditionKey = (inclusion: string, ...valueGroups: readonly (readonly string[])[]): string =>
    [inclusion, ...valueGroups.map((values) => [...normalizeValueGroup(values)].sort().join("|"))].join(":");
